import React from "react"
import {findDOMNode} from "react-dom"

import PopoverAddColumn from "../../../../../../gd-modules/common/add-column-new/popover/popover"
import Popover from "../../../../../../gd-components/gd-popover/popover"
import FieldSelectFields from "../../select-fields"
import convertFieldsStructureToConfig from "../../../../../../gd-modules/common/add-column-new/convert-fields-structure"

const debug = false
// const debug = "FieldSelectFields_Popover"

export default function FieldSelectFields_Popover(props:any) {

    const onSelect = (fieldId:ID) => {
        debug && console.log(debug, 'onSelect', fieldId)

        // props.parent.hidePopover()
        const newValues = props.value ? gd.utils.toggleArrayValue(props.value, fieldId) : [fieldId]

        debug && console.log(debug, 'onSelect newValues', newValues)

        props.parent.onValueChange(newValues, false)
    };

    const field : FieldSelectFields = props.field

    const manageColumnsConfig   = convertFieldsStructureToConfig(field.fieldsStructure, props.model?.restrictedFields)
    let columns                 = _.map(props.value, fieldId=>({fieldId}))

    debug && console.log(debug, 'render', props.value, columns)

    return (
        <Popover popoverClass   = "gd-popover-add-column-new h-300"
                 onClickOutside = {()=>props.parent.hidePopover()}
                 getTargetFunc  = {()=>findDOMNode(props.parent)}>
            <PopoverAddColumn manageColumnsConfig   = {manageColumnsConfig}
                              fields                = {field.fields.models}
                              columns               = {columns}
                              mandatoryColumnsIds   = {[]}
                              showAdd               = {false}
                              hidePopover           = {props.parent.hidePopover}
                              onToggleColumn        = {onSelect}
                              onNewCustomField      = {()=>{}}/>
        </Popover>
    )
}